function filterMap(arr, mapFunction) {
    const acc = [];
    for(let i = 0; i < arr.length; i++){
        const current = mapFunction(arr[i]);
        if (null != current) acc.push(current);
    }
    return acc;
}
const src_filterMap = filterMap;
export default src_filterMap;
export { filterMap };
